(($, Drupal) => {
  Drupal.behaviors.toTop = {
    attach(context, settings) {
      // Behavior вызывается несколько раз на странице, не забывайте использовать функцию .once().
      $('.footer__scrolltop').once('add').on('click', () => {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      });
    },
  };
})(jQuery, Drupal);
